module.exports = __webpack_public_path__ + "img/e7b0cd0.png";